import trans from "../../../utils";

function humanizeCamelCase(value) {
	return value
		.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
		.replace(/^./, (c) => c.toUpperCase());
}

// "unAssigned" mechanically splits to "Un Assigned", which reads oddly and
// wouldn't match the existing "Unassigned" translation — override it instead.
const LABEL_OVERRIDES = {
	unAssigned: "Unassigned",
};

function toOptions(values) {
	return values.map((value) => ({
		value,
		label: trans(LABEL_OVERRIDES[value] || humanizeCamelCase(value)),
	}));
}

export const TASK_PRIORITY_OPTIONS = toOptions(["low", "medium", "high"]);

export const TASK_TYPE_OPTIONS = toOptions([
	"inspection",
	"delivery",
	"survey",
	"maintenance",
	"other",
]);

export const TASK_STATUS_OPTIONS = toOptions([
	"unAssigned",
	"todo",
	"inProgress",
	"done",
]);
